import Vue from "vue";
import VueRouter from "vue-router";

import NotFoundComponent from "./NotFoundComponent.vue";
import about from "./views/about/about-main.vue";
import news from "./views/news-page/news-main.vue";
import newsAdd from "./views/news-page/news-add.vue";
import newsEdit from "./views/news-page/news-edit.vue";
import vacancies from "./views/vacancies/vacancies-main.vue";
import vacanciesAdd from "./views/vacancies/vacancies-add.vue";
import vacanciesEdit from "./views/vacancies/vacancies-edit.vue";
import settingsMain from "./views/settings-lk/settings-main.vue";
import credentials from "./views/credentials/credentials-main.vue";
import contacts from "./views/contacts/contacts-main.vue";
import organization from "./views/organization/organization-main.vue";
import mainpage from "./views/main-page/main-page.vue";
import documents from "./views/documents/documents-main.vue";
import announcement from "./views/announcement/announcement-main.vue";
import announcementAdd from "./views/announcement/announcement-add.vue";
import announcementEdit from "./views/announcement/announcement-edit.vue";
import settingsSite from "./views/settings-site/settings-main.vue";
import accounts from "./views/accounts/accounts-main.vue";
import accountInfo from "./views/accounts/account-info.vue";
import AlertsPage from "./views/AlertsPage/AlertsPage.vue";
import DeclinedAlertsPage from "./views/AlertsPage/DeclinedAlertsPage.vue";
import ModerateAlertsPage from "./views/AlertsPage/ModerateAlertsPage.vue";
import RequestsPage from "./views/requests/RequestsPage.vue";
import RequestPage from "./views/requests/RequestPage.vue";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: "",
    redirect: { name: "organization" }
  },
  {
    path: "/mainpage",
    name: "mainpage",
    component: mainpage
  },
  {
    path: "/about",
    name: "about",
    component: about
  },
  {
    path: "/news",
    component: news
  },
  {
    path: "/alerts",
    component: AlertsPage
  },

  {
    path: "/alerts/declined",
    component: DeclinedAlertsPage
  },
  {
    path: "/alerts/moderate",
    component: ModerateAlertsPage
  },
  {
    path: "/requests",
    component: RequestsPage
  },
  {
    path: "/requests/:id",
    component: RequestPage
  },
  {
    path: "/news/add",
    component: newsAdd
  },
  {
    path: "/news/edit/:id",
    component: newsEdit
  },
  {
    path: "/vacancies",
    component: vacancies
  },
  {
    path: "/vacancies/add",
    component: vacanciesAdd
  },
  {
    path: "/vacancies/edit/:id",
    component: vacanciesEdit
  },
  {
    path: "/settings",
    component: settingsMain
  },
  {
    path: "/credentials",
    component: credentials
  },
  {
    path: "/contacts",
    component: contacts
  },
  {
    name: "organization",
    path: "/organization",
    component: organization
  },
  {
    path: "/announcement",
    component: announcement
  },
  {
    path: "/announcement/add",
    component: announcementAdd
  },
  {
    path: "/announcement/edit/:id",
    component: announcementEdit
  },
  {
    path: "/documents",
    component: documents
  },

  {
    path: "/site-settings",
    component: settingsSite
  },
  {
    path: "/accounts",
    component: accounts
  },
  {
    path: "/accounts/:id",
    component: accountInfo
  },
  {
    path: "/404",
    name: "404",
    mode: "history",
    component: NotFoundComponent,
    meta: {
      role: "all"
    }
  },
  {
    path: "*",
    redirect: "/404"
  }
];

//let _TOKEN = window.$cookies.get('token_user_personal_PanelJFservice-organization')

//let _TOKEN = window.$cookies.get('time_token_die_adminOrg')

export const router = new VueRouter({
  routes,
  mode: "history"
});

/* 
router.beforeEach((to, from, next) => {
	_TOKEN = window.$cookies.get('time_token_die_adminOrg')
	
	if (process.env.NODE_ENV === 'development') {
		console.log('_TOKEN development', _TOKEN)
	}
	
	if (true) {
		//token.state.tokenValid = true
		//let dateExp = new Date() / 1000  +  (60 * 60 * 24 * 30, 60 * 60 * 24 * 30)
		//window.$cookies.set("time_token_die_adminOrg", dateExp, 60 * 60 * 24 * 30, null, process.env.VUE_APP_COOCKIE)
		next()
	} else {
		next()
		token.state.tokenValid = false
		window.$cookies.remove('time_token_die_adminOrg', '/', process.env.VUE_APP_COOCKIE)
		window.location.replace(process.env.VUE_APP_REDIRECT)
	}
})
 */

/* router.beforeEach((to, from, next) => {
	_TOKEN = window.$cookies.get('token_user_personal_PanelJFservice-organization')
	
	$axios.defaults.headers.Authorization = `Bearer ${_TOKEN}` //сохраняем токен для axios
	
	if (process.env.NODE_ENV === 'development') {
		console.log('_TOKEN', _TOKEN)
	}
	if (_TOKEN || _TOKEN !== 'null') {
		try {
			debearer = jwtDecode(_TOKEN)
		} catch (e) {
			window.location.replace(process.env.VUE_APP_REDIRECT)
		}
		if (debearer) {
			if (debearer.exp > Date.now() / 1000) {
				toNext = true
				token.state.tokenValid = true
			} else {
				toNext = false
				token.state.tokenValid = false
			}
		} else {
			_TOKEN = null
			toNext = false
			token.state.tokenValid = false
		}
		if (!toNext) {
			window.location.replace(process.env.VUE_APP_REDIRECT)
		} else {
			next()
		}
	} else {
		window.location.replace(process.env.VUE_APP_REDIRECT)
	}
}) */
